var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.92157 3 5.25 3.67157 5.25 4.5V19.5C5.25 20.3284 5.92157 21 6.75 21H17.25C18.0784 21 18.75 20.3284 18.75 19.5V8.25L13.5 3H6.75Z",
    fill: "#FF8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65972 17.7852C8.47075 17.7852 8.31694 17.6313 8.31694 17.4424C8.31694 17.2578 8.47075 17.104 8.65972 17.104C8.83989 17.104 8.9981 17.2578 8.9981 17.4424C8.9981 17.6313 8.83989 17.7852 8.65972 17.7852ZM9.42612 18.6465V15.3638H9.97544V15.7549H10.0106C10.0985 15.5835 10.2743 15.333 10.6961 15.333C11.2455 15.333 11.6805 15.7637 11.6805 16.5591C11.6805 17.3457 11.2586 17.7939 10.6961 17.7939C10.2831 17.7939 10.0985 17.5479 10.0106 17.3721H9.98862V18.6465H9.42612ZM9.97544 16.5547C9.97544 17.0205 10.1776 17.3325 10.5423 17.3325C10.9115 17.3325 11.1092 17.0073 11.1092 16.5547C11.1092 16.1108 10.9159 15.79 10.5423 15.79C10.1776 15.79 9.97544 16.0933 9.97544 16.5547ZM12.8952 17.7939C12.3327 17.7939 11.9108 17.3457 11.9108 16.5591C11.9108 15.7637 12.3458 15.333 12.8996 15.333C13.3214 15.333 13.4972 15.5835 13.5807 15.7549H13.6027V14.5684H14.1608V17.75H13.6115V17.3721H13.5807C13.4928 17.5479 13.3083 17.7939 12.8952 17.7939ZM13.049 17.3325C13.4093 17.3325 13.6159 17.0205 13.6159 16.5547C13.6159 16.0933 13.4137 15.79 13.049 15.79C12.6754 15.79 12.4821 16.1108 12.4821 16.5547C12.4821 17.0073 12.6798 17.3325 13.049 17.3325ZM15.8237 15.3638V15.7944H15.3315V17.75H14.769V15.7944H14.413V15.3638H14.769V15.1353C14.769 14.6694 15.059 14.4189 15.5161 14.4189C15.6479 14.4189 15.7666 14.4321 15.872 14.4541V14.8979C15.7797 14.8848 15.7094 14.8804 15.6699 14.8804C15.4414 14.8804 15.3315 14.9727 15.3315 15.188V15.3638H15.8237Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7790_33325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25V3L18.75 8.25H13.5Z",
    fill: "#E52222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7790_33325",
    x: 10.5,
    y: 1.5,
    width: 11.25,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7790_33325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7790_33325",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.f0c90a3d2d7f86305d46819ad158059d.svg";
export { ForwardRef as ReactComponent };